import { render, staticRenderFns } from "./ProofreadingSelectManuscript.vue?vue&type=template&id=d724983a&scoped=true"
import script from "./ProofreadingSelectManuscript.vue?vue&type=script&lang=ts"
export * from "./ProofreadingSelectManuscript.vue?vue&type=script&lang=ts"
import style0 from "./ProofreadingSelectManuscript.vue?vue&type=style&index=0&id=d724983a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d724983a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d724983a')) {
      api.createRecord('d724983a', component.options)
    } else {
      api.reload('d724983a', component.options)
    }
    module.hot.accept("./ProofreadingSelectManuscript.vue?vue&type=template&id=d724983a&scoped=true", function () {
      api.rerender('d724983a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/proofreading/ProofreadingSelectManuscript.vue"
export default component.exports